<div class="loader-container">
  <span [ngClass]="size() === 'sm' ? 'loader-sm' : 'loader'"></span>
</div>
